<template>
  <div class="dashboard-block">
    <h2>Booked {{ $starLabelPlural | sentenceCase }}</h2>

    <ul class="list-items">
      <booking-talent-list-item
        v-for="user in bookingTalents"
        :key="user.id"
        :user="user"
        :booking="booking"/>
    </ul>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingTalentListItem from './BookingTalentListItem'

export default {
  mixins: [helpers],

  components: {
    BookingTalentListItem
  },
  computed: {
    bookingTalents () {
      if (this.showAllTalents) {
        return this.booking.talentAttending
      } else {
        return this.bookingAttendingTalent
      }
    }
  },
  props: {
    booking: {
      type: Object,
      required: true
    },
    showAllTalents: {
      required: false,
      default: false
    }
  }
}
</script>
